"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link(props) {
  var contentState = props.contentState,
      children = props.children,
      entityKey = props.entityKey;

  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
      href = _contentState$getEnti.href,
      title = _contentState$getEnti.title;

  return /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    title: title
  }, children);
};

var _default = Link;
exports.default = _default;